<template>
  <div class="home">

    <ImageCarousel :images1="images" />

    <div
      class="container mt-3"
      style="text-align: left; margin-top: 3em !important"
    >
      <p style="font-weight: 600">Categorias</p>
      
      <CategoriesComponent :options="options" />

      <p style="font-weight: 600; margin-top: 1em; margin-bottom: 0 !important;">Em Destaque</p>

      <EventsHomepageComponent :events="eventOptions" />


      <div style="margin-top: 1.5em;display: flex;justify-content: center;">
        <a href="https://www.instagram.com/eupsi.julia/" style="display: flex;justify-content: center;"><img
          src="assets/banner_julia.png"
          class="d-block img-fluid last-banner"
          style="border-radius: 8px;max-width: 70%;"
          alt="..."
          href="https://www.instagram.com/eupsi.julia/"
        /></a>
      </div>

      <div class="container mt-3" style="padding: 0;display:flex; flex-direction: row;justify-content: space-between;">
        <div
          class="row justify-content-between mb-4"
          style="font-weight: 600; margin-left: 0.2em; "
        >
          Visite São Lourenço
        </div>
        <a style="font-weight: 600; color:#2F6787; text-decoration: none;" href="/attractions">Ver Todos</a>
      </div>

<AttractionsScrollComponent :options="attractionOptions"></AttractionsScrollComponent>

    
    </div>

    <!--secao para os topicos do app na home-->
  </div>
</template>
<style>


.small-div {
  position: absolute;
  bottom: 80px;
  left: 100px;
  /* transform: translateY(-155%); */
  width: 40px;
  height: 40px;
  background-color: white;
  border-radius: 8px;
  text-align: center;
}
.cat-text {
  margin-top: 0.2em;
  margin-bottom: 0.8em !important;
  color: #5fa8d3;
}
.topic {
  background-color: aliceblue;
  border-radius: 8px;
  text-decoration: none;
  color: inherit;
}

.carousel .carousel-indicators button {
  width: 10px;
  height: 10px;
  border-radius: 100%;
}

.carousel .carousel-indicators button {
  background-color: gray;
}

.carousel .carousel-indicators button.active {
  background-color: black;
}

.carousel-indicators {
  bottom: -3em;
}

.overflow-scroll {
  /*overflow-x: auto;*/
  overflow: hidden;
  /*white-space: nowrap;*/
/*  -webkit-overflow-scrolling: touch; /* Enable smooth scrolling on iOS devices */
}

/* Optional: Add styles for the card or customize as needed */
.card {
  width: 100%;
  background-color: #edf5fa;
  border-radius: 16px;
}

/* Media queries for smaller screens */
@media (max-width: 767px) {
  .overflow-scroll {
    flex-wrap: nowrap;
    overflow-x: auto;
 /* overflow: hidden !important;*/
  white-space: nowrap;
  -webkit-overflow-scrolling: touch; /* Enable smooth scrolling on iOS devices */
  }
  .col-xs-8 {
    width: 40%;
  }
  img.last-banner{
  max-width: 100% !important;
  height: 175px !important;
  width: 343px;
  border: 1px solid #000000;
}
}

@media (max-width: 575px) {
  .attr {
    width: 60%;
  }
  .cat {
    width: 40%;
  }
}
.scroll-container::-webkit-scrollbar {
  display: none;
}
.no-scroll {
  overflow: hidden;
}
</style>
<script>
//import { RouterLink } from "vue-router";
import ImageCarousel from "@/components/ImageCarousel.vue";
import CategoriesComponent from '@/components/CategoriesComponent.vue';
import AttractionsScrollComponent from '@/components/AttractionsScrollComponent.vue';
import EventsHomepageComponent from '@/components/EventsHomepageComponent.vue';
import attractionItems from "@/data/attractions/attractionItems.json"
import eventItems from "@/data/events/eventItems.json"

// @ is an alias to /src
//import HelloWorld from '@/components/HelloWorld.vue'

export default {
  data() {
    return {
      eventOptions: eventItems,
      attractionOptions: attractionItems,
      images: [
        "assets/rect1.svg",
        "assets/rect1.svg",
        "assets/rect1.svg"],
      options: [
        {
          description: "Turismo",
          destination: "/attractions",
          class1: "bi-camera",
          svgObj: { width: 25, height: 24, viewBox: "0 0 25 24" },
          path: {
            d: "M20.4426 4.9425C20.1576 4.6575 19.7826 4.5 19.3851 4.5H13.2576V1.5H11.7576V9H5.63014C5.23264 9 4.85014 9.1575 4.57264 9.4425L2.01514 12L4.57264 14.5575C4.85764 14.8425 5.23264 15 5.63014 15H11.7576V22.5H13.2576V10.5H19.3851C19.7826 10.5 20.1651 10.3425 20.4426 10.0575L23.0001 7.5L20.4426 4.9425ZM5.62263 13.5L4.12263 12L5.62263 10.5H11.7501V13.5H5.62263ZM19.3776 9H13.2501V6H19.3776L20.8776 7.5L19.3776 9Z",
          },
        },
        {
          description: "Gastronomia",
          destination: "/food",
          class1: "bi-camera",
          svgObj: { width: 21, height: 20, viewBox: "0 0 21 20" },
          path: {
            d: "M18 8.25C18 6.555 17.055 5.0775 15.6675 4.3125C16.1775 3.7725 16.5 3.0525 16.5 2.25H15C15 3.075 14.325 3.75 13.5 3.75C11.0475 3.75 9.04501 5.72249 9.00751 8.16749C8.04751 7.19249 7.5 5.8725 7.5 4.5C7.5 3.1275 6.54 1.94249 5.25 1.60499V0H3.75V1.60499C2.46 1.94249 1.5 3.105 1.5 4.5V8.25H0V9C0 14.79 4.71 19.5 10.5 19.5C16.29 19.5 21 14.79 21 9V8.25H18ZM13.5 5.25C15.1575 5.25 16.5 6.5925 16.5 8.25H10.5C10.5 6.5925 11.8425 5.25 13.5 5.25ZM3 4.5C3 3.675 3.675 3 4.5 3C5.325 3 6 3.675 6 4.5C6 5.85 6.41252 7.1475 7.14752 8.25H3V4.5ZM10.5 18C5.79 18 1.91253 14.3625 1.53003 9.75H19.47C19.0875 14.3625 15.21 18 10.5 18Z",
          },
        },
        {
          description: "Eventos",
          destination: "/events",
          class1: "bi-camera",
          svgObj: { width: 25, height: 24, viewBox: "0 0 25 24" },
          path: {
            d: "M22.2573 10.5C22.6698 10.5 23.0073 10.1625 23.0073 9.75V6C23.0073 5.175 22.3323 4.5 21.5073 4.5H3.50732C2.68232 4.5 2.00732 5.175 2.00732 6V9.75C2.00732 10.1625 2.34482 10.5 2.75732 10.5C3.58232 10.5 4.25732 11.175 4.25732 12C4.25732 12.825 3.58232 13.5 2.75732 13.5C2.34482 13.5 2.00732 13.8375 2.00732 14.25V18C2.00732 18.825 2.68232 19.5 3.50732 19.5H21.5073C22.3323 19.5 23.0073 18.825 23.0073 18V14.25C23.0073 13.8375 22.6698 13.5 22.2573 13.5C21.4323 13.5 20.7573 12.825 20.7573 12C20.7573 11.175 21.4323 10.5 22.2573 10.5ZM21.5073 14.9025V18H16.2573V15.75H14.7573V18H3.50732V14.9025C4.79732 14.5725 5.75732 13.395 5.75732 12C5.75732 10.605 4.79732 9.4275 3.50732 9.0975V6H14.7573V8.25H16.2573V6H21.5073V9.0975C20.2173 9.435 19.2573 10.605 19.2573 12C19.2573 13.395 20.2173 14.5725 21.5073 14.9025Z",
          },
        },
        {
          description: "Hospedagem",
          destination: "/hotels",
          class1: "bi-camera",
          svgObj: { width: 25, height: 24, viewBox: "0 0 24 24" },
          path: {
            d: "M18.75 10.5H12.75C11.925 10.5 11.25 11.175 11.25 12V16.5H3V7.94999L12 3.10499L21.3975 8.16749L22.11 6.84751L12.36 1.59751C12.1425 1.47751 11.8725 1.47751 11.6475 1.59751L1.89748 6.84751C1.65748 6.97501 1.5 7.22999 1.5 7.50749V22.5075H3V18.0075H21V22.5075H22.5V14.2575C22.5 12.1875 20.82 10.5075 18.75 10.5075V10.5ZM12.75 16.5V12H18.75C19.9875 12 21 13.0125 21 14.25V16.5H12.75Z",
          },
        },
        {
          description: "Compras",
          destination: "/services",
          class1: "bi-camera",
          svgObj: { width: 25, height: 24, viewBox: "0 0 24 24" },
          path: {
            d: "M21.57 8.51248C21.4275 8.34748 21.2175 8.25 21 8.25H16.5V5.25C16.5 4.0125 15.4875 3 14.25 3H9.75004C8.51254 3 7.50004 4.0125 7.50004 5.25V8.25H3.00004C2.78254 8.25 2.57254 8.34748 2.43004 8.51248C2.28754 8.67748 2.22754 8.9025 2.25754 9.1125L3.66004 18.225C3.77254 18.96 4.39504 19.5 5.14504 19.5H18.855C19.5975 19.5 20.2275 18.9675 20.34 18.225L21.7425 9.1125C21.7725 8.895 21.7125 8.67748 21.57 8.51248ZM9.00004 5.25C9.00004 4.8375 9.33753 4.5 9.75004 4.5H14.25C14.6625 4.5 15 4.8375 15 5.25V8.25H9.00004V5.25ZM18.855 18H5.14504L3.87753 9.75H20.13L18.8625 18H18.855Z",
          },
        },
      ],
    };
  },
  name: "HomeView",
  components: {
    //RouterLink,
    ImageCarousel,
    CategoriesComponent,
    AttractionsScrollComponent,
    EventsHomepageComponent
  },
};
</script>
